import * as utils from '../functions/utils';

export interface IBanner {
  bannerImageUrl: string;
  announcementType: string;
  destinationURL: string;
  announcementItemID: number | null;
}

export default class Banner {
  bannerImageUrl: string;
  announcementType: string;
  destinationURL: string;
  announcementItemID: number | null;

  constructor() {
    this.bannerImageUrl = '';
    this.announcementType = '';
    this.destinationURL = '';
    this.announcementItemID = null;
  }

  static mappingObject(_obj: any): IBanner | null {
    let obj: Banner | null = null;
    if (_obj) {
      obj = Object.assign(new Banner(), _obj);
      if (obj) {
        obj.bannerImageUrl = _obj.BannerImageUrl;
        obj.announcementType = _obj.AnnouncementType;
        obj.destinationURL = _obj.DestinationURL;
        obj.announcementItemID = _obj.AnnouncementItemID;
      }
      obj = utils.cleanObjectKeys(Object.keys(new Banner()), obj);
    }

    return obj;
  }
}
